import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=f19f0ae8&scoped=true"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"
import style0 from "./Embed.vue?vue&type=style&index=0&id=f19f0ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f0ae8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
